import { render } from "./InventoryHistory.vue?vue&type=template&id=0a671e02&scoped=true"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"

import "./InventoryHistory.vue?vue&type=style&index=0&id=0a671e02&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a671e02"]])

export default __exports__